import Vue from 'vue';
import Router from 'vue-router';

import Home from '@/pages/home';
import Correct from '@/pages/correct';
import AppointDetails from '@/pages/appoint_details';
import CorrectAppointDetail from '@/pages/correct_appoint_details';
import config from '@/config';
import API from '@/utils/http';
Vue.use (Router);

let router = new Router ({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/correct',
      name: 'correct',
      component: Correct,
    },
    {
      path: '/appoint_details',
      name: 'detail',
      component: AppointDetails,
    },
    {
      path: '/correct_appoint_details',
      name: 'correct_appoint_details',
      component: CorrectAppointDetail,
    },
  ],
});

router.beforeEach ((to, from, next) => {
  let redirect = window.location.origin + to.path;
  if (
    to.path === '/appoint_details' ||
    to.path === '/correct_appoint_details'
  ) {
    return next ();
  }
  if (localStorage.openid) return next ();
  let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${config.appId}&redirect_uri=${redirect}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;

  let code = to.query.code || '';

  // return;
  if (code) {
    localStorage.code = code;

    if (localStorage.openid) return next ();
    API.post ('/wechat_userinfos', {
      code,
    }).then (data => {
      if (data.code == 0) {
        localStorage.openid = data.data.openid;
      }
    });
  } else {
    window.location.href = url;
  }

  next ();
});

export default router;
